module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy2"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("© 2022 Emerging Civil War")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("First edition, first printing")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN-13 (hardcover): 978-1-61121-633-2")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN-13 (ebook): 978-1-61121-634-9")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN-13 (Mobi book): 978-1-61121-634-9")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('div', {
    staticClass: "sfont"
  }, [_c('p', {
    staticClass: "copyh"
  }, [_vm._v("Names: Tracey, Jon, editor. | Mackowski, Chris, editor.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Title: Civil War monuments and memory : favorite stories and fresh perspectives from the historians at Emerging Civil War / edited by Jon Tracey and Christopher Mackowski.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Other titles: Emerging Civil War (Blog)")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Description: El Dorado Hills, CA : Savas Beatie LLC, [2022] | Series: Emerging Civil War anniversary series | Summary: «This collection of essays explores some of the ways people monumented and memorialized the war-and how those markers have impacted our understanding of it. It is designed to shed new light and insight on the monuments and memorials that give us some of our most iconic and powerful connections to the battlefields and the men who fought there»-- Provided by publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Identifiers: LCCN 2022006581 | ISBN 9781611216332 (hardcover) | ISBN 9781611216349 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Subjects: LCSH: United States--History--Civil War, 1861-1865--Monuments. | United States--History--Civil War, 1861-1865--Battlefields—Conservation and restoration. | Soldiers› monuments--United States--History. | Soldiers› monuments--Southern States--History. | Memorialization—United States. | Collective memory--United States.")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("Classification: LCC E641 .C584 2022 | DDC 973.7/6--dc23/eng/20220310")]), _vm._v(" "), _c('p', {
    staticClass: "copyh"
  }, [_vm._v("LC record available at "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2022006581",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://lccn.loc.gov/2022006581")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_containerc"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/copy.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Savas Beatie")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("989 Governor Drive, Suite 102")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("El Dorado Hills, CA 95762")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("916-941-6896 / "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:sales@savasbeatie.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("sales@savasbeatie.com")])])]), _vm._v(" / "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.savasbeatie.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.savasbeatie.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All of our titles are available at special discount rates for bulk purchases in the United States. Contact us for information.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Proudly published, printed, and warehoused in the United States of America.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f8513ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Copyright.vue
// module id = 66
// module chunks = 0